export default "__VITE_ASSET__66b42ef1__"